import React from 'react'
import Layout from '../../layout/Layout'
import MyCalendar from '../../components/settings/MyCalendar';

function Calendar() {

    return (
        <Layout title="Calendar ">
            <main>
                <div className="card page-card p-4">
                    <MyCalendar />
                </div>
            </main>
        </Layout>
    )
}

export default Calendar